onDomReady(() => {
   when($('js-iso-language-dropdown-button'), button => {
      window.languageDropdownButton.setProps({
         translationPreferencesUrl: App.translationPreferencesUrl,
         languages: App.languages,
      });
      window.languageDropdownButton.setRenderTarget($('js-iso-lang-dropdown'));

      window.languageDropdownButton.renderDropdown();
      button.addEvent('click', window.languageDropdownButton.toggle);
   });
});
